import { UserType } from '@avanta/shared/constants/users';
import { type Employee } from './employees';
import { type AdminEnterprise, type Enterprise } from './enterprises';
import { type Patient } from './patients';
import { type Psychologist } from './psychologists';
import { type Supporter } from './supporter';

export interface BaseUser {
  banned: boolean;
  email: string;
  id: string;
}

export const ALL_USER_TYPES = [
  UserType.SUPPORTER,
  UserType.PATIENT,
  UserType.EMPLOYEE,
  UserType.PSYCHOLOGIST,
  UserType.ENTERPRISE,
  UserType.ADMIN_ENTERPRISE,
];

export interface User
  extends
    Omit<Patient, 'type'>,
    Omit<Employee, 'type'>,
    Omit<Enterprise, 'type'>,
    Omit<AdminEnterprise, 'type'>,
    Omit<Supporter, 'type'>,
    Omit<Psychologist, 'type'> {
  type: UserType;
}
